/* import __COLOCATED_TEMPLATE__ from './plaid-linking-direct-debit-mandate-step.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();